import { render, staticRenderFns } from "./WorkerWizardPage.vue?vue&type=template&id=6a3bdf1c&"
import script from "./WorkerWizardPage.vue?vue&type=script&lang=js&"
export * from "./WorkerWizardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports